(function ($) {
	'use strict';

	$(document).on('facetwp-loaded', function () {
		// Modified from...
		// https://facetwp.com/help-center/facets/#how-to-add-labels-headings-above-each-facet
		$('.facetwp-facet').each(function () {
			const facet = $(this);
			const facet_name = facet.attr('data-name');
			const facet_type = facet.attr('data-type');
			const facet_label = FWP.settings.labels[facet_name];

			if (facet_type !== 'pager' && facet_type !== 'sort') {
				if (facet.closest('.facet').length < 1 && facet.closest('.facetwp-flyout').length < 1) {
					facet.wrap('<div class="facet"></div>');
					facet.before('<label class="facet__label">' + facet_label + '</label>');

					if (facet_type !== 'checkboxes') {
						const facet_input = facet.find('input, select');
						facet_input.attr('id', `facet-${facet_name}`);
						facet.prev('.facet__label').attr('for', `facet-${facet_name}`);
					}
				}
			}

			if (facet_type === 'pager' && facet_name.indexOf('pagination') > -1) {
				const pager = facet.find('.facetwp-pager');

				if (pager.is(':empty')) {
					facet.closest('.l-section').css('display', 'none');
				} else {
					facet.closest('.l-section').css('display', 'block');
				}
			}
		});

		// https://facetwp.com/how-to-scroll-the-page-on-facet-interaction/
		if (FWP.enable_scroll == true || ($('.js-report-facets').length > 0 && '' != FWP.buildQueryString())) {
			$('html, body').animate({
				scrollTop: $('.facetwp-template').offset().top
			}, 500);
		}
	});

	$(document).on('facetwp-refresh', function () {
		if (FWP.soft_refresh == true) {
			FWP.enable_scroll = true;
		} else {
			FWP.enable_scroll = false;
		}
	});

	$(function () {
		const facetShelves = [...document.querySelectorAll('.js-facets-shelf')];
		const facetShelfMq = window.matchMedia('(min-width: 768px)');

		facetShelves.forEach(shelf => {
			const toggle = shelf.querySelector('.js-facets-toggle');
			const $facets = $(shelf).find('.js-facets');

			if (!facetShelfMq.matches) {
				$facets.hide();
			}

			toggle.addEventListener('click', (e) => {
				e.preventDefault();

				if ($facets.css('display') !== 'none') {
					toggle.textContent = 'Show filters';
				} else {
					toggle.textContent = 'Hide filters';
				}

				$facets.slideToggle();
			});

			facetShelfMq.addEventListener("change", () => {
				if (facetShelfMq.matches) {
					$facets.show(0);
					toggle.textContent = 'Show filters';
				} else {
					$facets.hide(0);
				}
			});
		});
	});
})(jQuery);
